import React, { useEffect, useState } from 'react';
import { CompoundButton, IconButton, Label, Spinner, SpinnerSize } from '@fluentui/react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

// component Functions
import * as ComponentFunctions from './PractitionerConcept.Item.Functions';

// components
import PractitionerProtocolConceptFormComponent from '../../PractitionerProtocolConceptsForm/PractitionerProtocolConceptForm.Component';
import ConfirmDialog from '../../../../../commons/component/ConfirmDialog/ConfirmDialog';

// styles
import './PractitionerConcept.Item.Styles.css';



const PractitionerConceptItem = (props: ComponentFunctions.Props) => {

    const { t } = useTranslation();

    const [isOpenItemConceptForm, setIsOpenItemConceptForm] = useState(false);
    const openSettingFormPanel = () => setIsOpenItemConceptForm(true);
    const dismissSettingFormPanel = () => setIsOpenItemConceptForm(false);

    const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);

    // useEffects
    useEffect(() => {
        if (props.ContractId) {
            props.GetContractById(props.CommissionAgentConcept.contractId);
        }
    }
    , [props.Contract == undefined]);

    useEffect(() => {
        if (props.CommissionAgentId) {
            props.GetContractCommissionAgentById(props.CommissionAgentId, props.Contract.id);
        }
    }
    , [props.Contract !== undefined && props.Agent === undefined]);

    useEffect(() => {
        if (props.SavingSuccessfully && isOpenItemConceptForm) {
            dismissSettingFormPanel();
        }
    }, [props.SavingSuccessfully]);

    // events
    const onClick = () => {
        openSettingFormPanel();
        props.onClick && props.onClick(props.CommissionConcept.id);
    };

    const onDelete = (e: any) => {
        e.stopPropagation();
        setConfirmDeleteOpen(true);
    }

    const onConfirmDelete = () => {
        setConfirmDeleteOpen(false);
        setIsDeleting(true);
        props.Agent && props.DeleteContractCommissionAgentConcept(props.Agent.id, props.CommissionAgentConcept.id, props.CommissionAgentConcept.contractId);
    }

    const onCancelDelete = () => {
        setConfirmDeleteOpen(false);
    }

    const onCancelForm = () => dismissSettingFormPanel();

    // Formatear información del concepto
    const getConceptInfo = () => {
        if (!props.CommissionConcept) return '';
        const parts = [];
        
        // Determinar el tipo de valorización
        switch (props.CommissionConcept.valuationType) {
            case 1: // Valor Fijo
                parts.push('Valor Fijo');
                if (props.CommissionConcept.value > 0) {
                    parts.push(`${props.CommissionConcept.currencyCode} ${props.CommissionConcept.value}`);
                }
                break;
            case 3: // Porcentaje
                parts.push('Porcentaje');
                if (props.CommissionConcept.value > 0) {
                    parts.push(`${props.CommissionConcept.value}%`);
                }
                break;
            case 4: // Lista de Precio
                parts.push('Por Lista de Precio');
                break;
            default:
                parts.push(`Tipo ${props.CommissionConcept.valuationType}`);
                break;
        }
        
        if (props.CommissionConcept.remoteValue > 0) {
            parts.push(`Remoto: ${props.CommissionConcept.currencyCode} ${props.CommissionConcept.remoteValue}`);
        }
        
        // Indicar sobre qué se aplica
        if (props.CommissionConcept.takeOnAlreadyPaid) {
            parts.push('Sobre lo cobrado');
        } else if (props.CommissionConcept.takeOnAlreadyRealized) {
            parts.push('Sobre lo realizado');
        }
        
        return parts.join(' • ');
    };

    const Forms = (
        <>
            <PractitionerProtocolConceptFormComponent
                isOpen={isOpenItemConceptForm}
                openPanel={() => undefined}
                dismissPanel={onCancelForm}
                CommissionAgentId={props.CommissionAgentConcept.commissionAgentId}
                CommissionAgentConceptId={props.CommissionAgentConcept.id}
                ContractId={props.CommissionAgentConcept.contractId}
            />
        </>
    )

    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <CompoundButton
                className='CommissionAgentConceptContainer'
                text={props.CommissionConcept.payByVisit ? 'Pago por visita' : `Pago por concepto: ${props.Concept?.concept.conceptName || ''}`}
                secondaryText={getConceptInfo()}
                onClick={onClick}
                disabled={props.disabled}
                styles={{ root: { flexGrow: 1, textAlign: 'left' } }}
            />
            <IconButton
                iconProps={{ iconName: 'Delete' }}
                disabled={props.disabled || isDeleting}
                onClick={onDelete}
                {...(isDeleting && { onRenderIcon: () => <Spinner size={SpinnerSize.small} /> })}
            />
            {Forms}
            <ConfirmDialog
                open={confirmDeleteOpen}
                title={t('practitionerConcepts.confirmDelete.title', 'Confirmar eliminación')}
                message={t('practitionerConcepts.confirmDelete.message', '¿Está seguro que desea eliminar este concepto?')}
                highlight={props.CommissionConcept?.payByVisit ? 'Pago por visita' : props.Concept?.concept.conceptName}
                confirmText={t('common.delete', 'Eliminar')}
                cancelText={t('common.cancel', 'Cancelar')}
                onCancel={onCancelDelete}
                onConfirm={onConfirmDelete}
            />
        </div>
    );
}

export default connect(
    ComponentFunctions.mapStateToProps,
    ComponentFunctions.mapDispatchToProps
)(PractitionerConceptItem as any);